import api from '@/services/api'

export default {
  namespaced: true,
  state() {
    return {
      loading: false,
      error: null,
    }
  },
  mutations: {
    SET_LOADING( state, status ) {
      state.loading = status
    },
    SET_ERROR( state, error ) {
      state.error = error
    },
  },
  actions: {
    async createReservation( { commit }, reservation ) {
      commit( 'SET_LOADING', true )
      commit( 'SET_ERROR', null )

      try {
        const response = await api.createReservation( reservation )
        return response.data
      } catch( error ) {
        const errorCode = error?.response?.data?.code || 'reservation_failed'
        commit( 'SET_ERROR', errorCode )
        throw error
      } finally {
        commit( 'SET_LOADING', false )
      }
    }
  }
}